import { useState } from "react";
import { useLocation } from "react-router-dom";
import ArtLabelsQueue from "./ArtLabelsQueue";
import ArtLabelsLibrary from "./ArtLabelsLibrary";

export const TABS = [
    { key: "queue", label: "Pendentes de pedidos" },
    { key: "library", label: "Biblioteca" },
];

/** Artes estendidas: fila de pedidos (padrão) e biblioteca (spec §5.3). */
const ArtLabelsPage = () => {
    const location = useLocation();
    const [tab, setTab] = useState(location?.state?.tab === "library" ? "library" : "queue");

    return (
        <div className="p-4 text-left">
            <h2 className="mb-2 text-xl text-orange-500">Artes estendidas</h2>
            <div role="tablist" className="mb-3 flex gap-2">
                {TABS.map((t) => (
                    <button
                        key={t.key}
                        type="button"
                        role="tab"
                        aria-selected={tab === t.key}
                        onClick={() => setTab(t.key)}
                        className={`px-3 py-1 ${tab === t.key ? "bg-[#d59106] text-black" : "border border-[#d59106]"}`}
                    >
                        {t.label}
                    </button>
                ))}
            </div>
            {tab === "queue" ? <ArtLabelsQueue /> : <ArtLabelsLibrary />}
        </div>
    );
};

export default ArtLabelsPage;
